/**
 * #4271 — a lista da TELA DE CONEXÕES não é a lista de operação.
 *
 * O `WhatsAppsContext` serve todo o app e, de propósito, vem recortada às
 * conexões liberadas para o usuário: é com ela que se atende. Administrar
 * (gerar QR, reiniciar, excluir) é outra coisa — um admin restrito a uma
 * conexão não conseguia administrar as demais, nem se liberar. Por isso a tela
 * pede a lista completa à parte (`?scope=connections`).
 *
 * O que o backend devolveu ali é uma FOTO do momento do carregamento: o status
 * muda depois, por socket, e quem recebe esses eventos é o contexto global.
 * Então a foto entra como base (define QUAIS conexões a tela mostra) e o
 * registro do contexto sobrescreve campo a campo (define o ESTADO de cada uma).
 *
 * Mesclar assim evita a alternativa ruim: assinar o socket de novo aqui, o que
 * processaria cada evento duas vezes.
 */
export const mergeManagedConnections = (managed, live) => {
  const aoVivo = Array.isArray(live) ? live : [];

  // Sem a lista administrativa (atendente, ou a requisição falhou), a tela
  // continua com o que a operação enxerga — nunca com a tela vazia.
  if (!Array.isArray(managed)) return aoVivo;

  const porId = new Map(aoVivo.map(conexao => [conexao.id, conexao]));

  return managed.map(conexao => {
    const atual = porId.get(conexao.id);
    return atual ? { ...conexao, ...atual } : conexao;
  });
};

/** Quem pode pedir `?scope=connections` — o backend responde 403 aos demais. */
export const podeAdministrarConexoes = user =>
  Boolean(user) && (user.profile === "admin" || Boolean(user.super));
